export default {"src":"/_next/static/media/arrow-hover.f440b3cd.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};